export type RecoveryNetworkScope =
  | 'blocked'
  | 'auth_refresh'
  | 'storage_upload'
  | 'storage_info';

const RECOVERY_OBJECT_PATH =
  /^\/storage\/v1\/object\/recovery_diagnostics\/[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}\/[0-9]{8}T[0-9]{6}Z-[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}\.agrec$/i;

interface RecoveryNetworkRequest {
  scope: RecoveryNetworkScope;
  supabaseUrl: string;
  requestUrl: string;
  method: string;
  expectedObjectPath?: string;
  upsertHeader?: string | null;
}

export const isRecoverySupabaseRequestAllowed = ({
  scope,
  supabaseUrl,
  requestUrl,
  method,
  expectedObjectPath,
  upsertHeader,
}: RecoveryNetworkRequest): boolean => {
  if (scope === 'blocked') return false;

  let expectedOrigin: string;
  let request: URL;
  try {
    expectedOrigin = new URL(supabaseUrl).origin;
    request = new URL(requestUrl);
  } catch {
    return false;
  }

  if (request.origin !== expectedOrigin) {
    return false;
  }

  if (scope === 'auth_refresh') {
    return (
      method.toUpperCase() === 'POST' &&
      request.pathname === '/auth/v1/token' &&
      request.search === '?grant_type=refresh_token'
    );
  }

  if (!expectedObjectPath || !RECOVERY_OBJECT_PATH.test(
    `/storage/v1/object/recovery_diagnostics/${expectedObjectPath}`
  )) {
    return false;
  }

  const expectedUploadPath = `/storage/v1/object/recovery_diagnostics/${expectedObjectPath}`;
  const expectedInfoPath = `/storage/v1/object/info/recovery_diagnostics/${expectedObjectPath}`;
  let decodedPath: string;
  try {
    decodedPath = decodeURIComponent(request.pathname);
  } catch {
    return false;
  }

  if (request.search !== '') return false;
  if (scope === 'storage_info') {
    return method.toUpperCase() === 'GET' && decodedPath === expectedInfoPath;
  }

  return (
    method.toUpperCase() === 'POST' &&
    decodedPath === expectedUploadPath &&
    (upsertHeader === undefined || upsertHeader === null || upsertHeader === 'false')
  );
};
